import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
// Bundled Spanish fallback (copied from backend by scripts/copyLocales.js on
// prebuild). Ensures the landing prerenders with real text under react-snap,
// when the /api/i18n backend is unreachable during the build. The http-backend
// still overlays fresh values at runtime.
import landingEs from './generated/locales/es/landing.json';
import commonEs from './generated/locales/es/common.json';

// Translations are served by the backend from PostgreSQL (cached in Redis):
//   GET /api/i18n/{{lng}}/{{ns}}
// Keys are flat (dots are literal, not nesting) — see keySeparator:false below.
const API = process.env.REACT_APP_API_URL || '/api';

export const SUPPORTED_LANGUAGES = [
  { code: 'es', label: 'Español' },
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'Français' },
  { code: 'de', label: 'Deutsch' },
];

export const LANGUAGE_CODES = SUPPORTED_LANGUAGES.map((l) => l.code);

// Namespaces map 1:1 to backend translation namespaces / source JSON files.
export const NAMESPACES = ['common', 'auth', 'teacher', 'creator', 'exam', 'landing', 'student', 'planner', 'evidence', 'materials', 'community', 'school', 'diagnostic', 'mobile', 'classwork', 'templates', 'career', 'formats', 'tools'];

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'es',
    supportedLngs: LANGUAGE_CODES,
    nonExplicitSupportedLngs: true, // navigator 'en-US' → 'en'
    load: 'languageOnly',
    // Bundled es fallback + on-demand loading of everything else from the API.
    partialBundledLanguages: true,
    resources: {
      es: { landing: landingEs, common: commonEs },
    },
    // Only preload 'common'; other namespaces load on demand per component
    // (useTranslation('teacher') etc.), which avoids loading every namespace
    // on every page.
    ns: ['common'],
    defaultNS: 'common',
    keySeparator: false, // flat keys like 'login.title'
    nsSeparator: ':',
    interpolation: { escapeValue: false }, // React already escapes
    backend: {
      loadPath: `${API}/i18n/{{lng}}/{{ns}}`,
    },
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lng',
      lookupLocalStorage: 'eva_lang',
      caches: ['localStorage'],
    },
    react: { useSuspense: true },
  });

export default i18n;
